import React from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'
import { Button, Form, Image, Input, Progress } from 'semantic-ui-react'
import { useAuth } from '../../context/authContext'
import db, { storage } from '../../utils/firebase'
import ListaDeTiposDePeliculas from '../listaDeTiposDePeliculas/ListaDeTiposDePeliculas'
import noImage from '../../img/noimage.png'
import {v4 as uuidv4} from 'uuid'
import { map } from 'lodash'
import "./AdminModificarAlbum.scss"




function AdminModificarAlbum({uuidPoster,dataPeli}) {



    const [iseLoading, setIsloading] = React.useState(false)
    const [files, setFiles] = React.useState(null)
    const [porcentajePoster, setPorcentajePoster] = React.useState(null)
    const [tipoDePelicula,setTipoDePelicula] = React.useState(dataPeli?.type)
    const [urlVideoForm,setUrlVideoForm] = React.useState()
    const [errors,setErrors] = React.useState({})
    const {setShowModal} = useAuth()
    const [buscar,setBuscar]=React.useState(dataPeli?.buscar?dataPeli?.buscar:[])
    const [reload,setReload]=React.useState(false)


    
    const [albumName, setAlbumName] = React.useState({
        type:tipoDePelicula,
        title:dataPeli?.title,
        description:dataPeli?.description,
        urlTrailer:dataPeli?.trailer,
        urlVideo:dataPeli?.video,
        buscar:[],
        urlImagePoste:dataPeli?.urlPoster

    })



    const onDrop = React.useCallback((acceptedFiles) =>{
        const file = acceptedFiles[0]
        setFiles(file)
        setUrlVideoForm(URL.createObjectURL(file))

    },[])
    

    const {getRootProps,getInputProps } = useDropzone({
        accept:" image/jpeg, image/png, image/jpg",
        maxFiles:3,
        noKeyboard: true,
        onDrop
    })

    const uploadPoster = (filePoster) =>{
        const ref = storage.ref().child(`peliculas/${filePoster}`)
        return ref.put(files)
    }

    const onSubmit= () =>{
        

        setErrors([])
        
        let error = {}
        let formOK = true

        

        if(formOK)
        if(albumName.urlImagePoste.length>2){

            if(buscar.length>0){
                db.collection("peliculas").doc(dataPeli.id).update({

                    video: albumName.urlVideo,
                    createAt:new Date(),
                    type: albumName.type ,
                    title: albumName.title,
                    description: albumName.description,
                    trailer: albumName.urlTrailer,
                    uuidPoster:dataPeli?.uuidPoster,
                    urlPoster:albumName.urlImagePoste,
                    buscar:buscar
                    
                }).then(() =>{
                    toast.success("Se subio con exito")
                }).finally(() =>{
                    setIsloading(false)
                    setShowModal(false)
                })


            }else{

                db.collection("peliculas").doc(dataPeli.id).update({

                    video: albumName.urlVideo,
                    createAt:new Date(),
                    type: albumName.type ,
                    title: albumName.title,
                    description: albumName.description,
                    trailer: albumName.urlTrailer,
                    uuidPoster:dataPeli?.uuidPoster,
                    urlPoster:albumName?.urlImagePoste,
                    
                }).then(() =>{
                    toast.success("Se subio con exito")
                }).finally(() =>{
                    setIsloading(false)
                    setShowModal(false)
                })

            }

        }else{

            setIsloading(true)
            const filePoster = uuidv4()
            uploadPoster(filePoster).on("state_changed",(snapshot) =>{
                const progressPorcentaje = Math.round(
                    (snapshot.bytesTransferred/snapshot.totalBytes)*100
                )
                setPorcentajePoster(progressPorcentaje)
            },
            (err) =>{
            },
            () =>{
                if(files){

                    storage.ref(`peliculas/${dataPeli.uuidPoster}`).delete().then(()=>{
    
                        storage.ref(`peliculas/${filePoster}`).getDownloadURL().then((url)=>{
        
                            
        
                            db.collection("peliculas").doc(dataPeli.id).update({
    
                                video: albumName.urlVideo,
                                createAt:new Date(),
                                type: albumName.type ,
                                title: albumName.title,
                                description: albumName.description,
                                trailer: albumName.urlTrailer,
                                uuidPoster:files ? filePoster:dataPeli?.uuidPoster,
                                urlPoster:files ? url:dataPeli?.urlPoster
                                
                            }).then(() =>{
                                toast.success("Se subio con exito")
                            }).finally(() =>{
                                setIsloading(false)
                                setShowModal(false)
                            })
                        }).catch((err)=>{
                            toast.error("Error al subir pelicula")
                        })
                    }).catch((err)=>{
                        storage.ref(`peliculas/${filePoster}`).getDownloadURL().then((url)=>{
        
                            
        
                            db.collection("peliculas").doc(dataPeli.id).update({
    
                                video: albumName.urlVideo,
                                createAt:new Date(),
                                type: albumName.type ,
                                title: albumName.title,
                                description: albumName.description,
                                trailer: albumName.urlTrailer,
                                uuidPoster:files ? filePoster:dataPeli?.uuidPoster,
                                urlPoster:files ? url:dataPeli?.urlPoster
                                
                            }).then(() =>{
                                toast.success("Se subio con exito")
                            }).finally(() =>{
                                setIsloading(false)
                                setShowModal(false)
                            })
                        }).catch((err)=>{
                            toast.error("Error al subir pelicula")
                        })

                    })
                }else{
                    if(buscar.length>0){
                        db.collection("peliculas").doc(dataPeli.id).update({
    
                            video: albumName.urlVideo,
                            createAt:new Date(),
                            type: albumName.type ,
                            title: albumName.title,
                            description: albumName.description,
                            trailer: albumName.urlTrailer,
                            uuidPoster:dataPeli?.uuidPoster,
                            urlPoster:dataPeli?.urlPoster,
                            buscar:buscar
                            
                        }).then(() =>{
                            toast.success("Se subio con exito")
                        }).finally(() =>{
                            setIsloading(false)
                            setShowModal(false)
                        })


                    }else{

                        db.collection("peliculas").doc(dataPeli.id).update({
    
                            video: albumName.urlVideo,
                            createAt:new Date(),
                            type: albumName.type ,
                            title: albumName.title,
                            description: albumName.description,
                            trailer: albumName.urlTrailer,
                            uuidPoster:dataPeli?.uuidPoster,
                            urlPoster:dataPeli?.urlPoster,
                            
                        }).then(() =>{
                            toast.success("Se subio con exito")
                        }).finally(() =>{
                            setIsloading(false)
                            setShowModal(false)
                        })

                    }
    
                        
                    
                }


            }
            
            )
        }

        

    }

    const AgregarBuscar = () =>{

        if(albumName.buscar.length>0){
            buscar.push(albumName.buscar.toLowerCase())
            setReload(!reload)
        }
        
    }

    const deleteButtom = (i)=>{
        const news = buscar.filter((doc)=>doc !==i)
        setBuscar(news)
        setReload(!reload)
    }


  return (
    <>

        <Form onSubmit={onSubmit} className="add-banner-form" > 

            
                <Form.Field className="banner-form-video" >

                    <div 
                        {...getRootProps()}
                        className="banner-video"
                        style={{backgroundImage: `url('${urlVideoForm ? urlVideoForm : dataPeli?.urlPoster}')`}}
                    />
                    <input {...getInputProps()} />
                    {!urlVideoForm && <Image src={noImage} />}
                

                </Form.Field>
                <Form.Field>
                    
                    <ListaDeTiposDePeliculas
                        obtenerListaSeleccionada={setTipoDePelicula}
                        type={albumName?.type}
                        typeShow={true}

                    />
                <Input
                        placeholder="Ingrese URL DE IMAGEN POSTE"
                        onChange={(e) => setAlbumName({...albumName,urlImagePoste: e.target.value })}
                        defaultValue={albumName?.urlImagePoste}
                />
                <Input
                        placeholder="Ingrese titulo de la pelicula"
                        onChange={(e) => setAlbumName({...albumName,title: e.target.value })}
                        defaultValue={dataPeli?.title}
                />
                <Input
                        placeholder="Ingrese descripcion"
                        onChange={(e) => setAlbumName({...albumName,description: e.target.value })}
                        defaultValue={dataPeli?.description}

                />
                <Input
                        placeholder="Ingrese URL TRAILER"
                        onChange={(e) => setAlbumName({...albumName,urlTrailer: e.target.value })}
                        defaultValue={dataPeli?.trailer}

                />
                <Input
                        placeholder="Ingrese URL VIDEO"
                        onChange={(e) => setAlbumName({...albumName,urlVideo: e.target.value })}
                        defaultValue={dataPeli?.video}

                />
                
                <Button type="submit" loading={iseLoading} >Crear Pelicula</Button>

                </Form.Field>
                <Progress percent={porcentajePoster}/>
                
            </Form>
                <Input
                        placeholder="Buscar"
                        onChange={(e) => setAlbumName({...albumName,buscar: e.target.value })}

                />
                <div className='conatinerButtoms' >
                    {
                        map(buscar,(item,index)=>(
                            <Button
                                key={index}
                                className='buttomAgregados'
                                onClick={()=>deleteButtom(item)}
                                
                            >
                                {item}
                            </Button>
                        ))
                    }
                </div>
                <Button  onClick={()=>AgregarBuscar()}  >agregar</Button>
    </>
  )
}

export default AdminModificarAlbum